<template>
  <section>
    <div class="row">
      <div class="col-md-12">

        <div class="mt-3 alert-info p-2 font-weight-bold" role="alert" v-show="!isContractAccepted">
          <i class="fas fa-info-circle"></i> กรุณาเลื่อนอ่านจนถึงบรรทัดสุดท้าย
        </div>

        <div v-show="professional" :class="['box-content card card-body mt-0 document',isContractAccepted == true ? 'is-accepted':'is-not-accepted']" ref="box-content">
          <!--    เอกสารแสดงความยินยอมให้เปิดเผยข้อมูลส่วนบุคคล      -->
          <consent-to-dis-close :professional="professional"></consent-to-dis-close>
          <hr>

          <!--  นโยบายคุ้มครองข้อมูลส่วนบุคคล  -->
          <personal-data-protection-policy></personal-data-protection-policy>
          <hr>

          <!--    การสมัครเป็นสมาชิกของบีนีท      -->
          <register-document :professional="professional"></register-document>
          <hr>

          <!--    สิทธิประโยชน์ของสมาชิกบีนีท      -->
          <benefits-document></benefits-document>
          <hr>

          <!-- ข้อตกลงการเป็นผู้ให้บริการอิสระบีนีท      -->
          <service-provider-agreement></service-provider-agreement>
          <hr>

          <!--    สัญญาการเก็บรักษาข้อมูลเป็นความลับ (NDA)      -->
          <data-secret-document :professional="professional"></data-secret-document>
        </div>


        <div class="box-button text-right my-3" v-if="!isContractAccepted">
          <button @click.prevent="accept"
                  :disabled="!isScrollToBottom"
                  :class="['button button-large', isScrollToBottom ? '-cyan' : '']">
            ยอมรับ
          </button>
        </div>


      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import RegisterDocument from './RegisterDocument.vue'
import BenefitsDocument from './BenefitsDocument.vue'
import ServiceProviderAgreement from './ServiceProviderAgreement.vue'
import DataSecretDocument from './DataSecretDocument.vue'
import ConsentToDisClose from './ConsentToDisClose.vue'
import PersonalDataProtectionPolicy from './PersonalDataProtectionPolicy.vue'

export default {
  name: 'ProfessionalDocument',
  components: {
    PersonalDataProtectionPolicy,
    'consent-to-dis-close': ConsentToDisClose,
    DataSecretDocument,
    ServiceProviderAgreement,
    BenefitsDocument,
    RegisterDocument
  },
  data () {
    return {
      isScrollToBottom: false,
      professional: null,
      isContractAccepted: false
    }
  },
  methods: {
    debounce (func, timeout) {
      let timer
      return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => { func.apply(this, args) }, timeout)
      }
    },
    async getProfessionalDetail (professionalId) {
      const { data } = await axios.get('professionals/' + professionalId, {
        headers: {
          'UserType': 'professional'
        }
      })
      this.professional = data.professional
      this.isContractAccepted = !!data.professional.is_contract_accepted
    },
    accept () {
      console.log('accept submit ')
      this.$router.replace({ path: `/cleaner/${this.$route.params.id}/contracts/2` })
    }
  },
  mounted () {
    const elementBox = this.$refs['box-content']

    elementBox.addEventListener('scroll', this.debounce((event) => {
      const { scrollHeight, scrollTop, clientHeight } = event.target
      const checkIsBottom = (scrollHeight - clientHeight - (scrollTop + 50)) <= 0
      if (checkIsBottom) {
        this.isScrollToBottom = true
      }
    }, 200))
  },
  created () {
    const professionalId = this.$route.params.id || null
    this.getProfessionalDetail(professionalId)
  }
}
</script>

<style scoped lang="scss">
.document {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.is-not-accepted {
  max-height: calc(100vh - 130px);
}

.is-accepted {
  max-height: calc(100vh);
}

.box-content {

  overflow-y: scroll;

  box-shadow: 0px 5px 3px -7px rgba(0, 0, 0, 1);
  -webkit-box-shadow: 0px 5px 3px -7px rgba(0, 0, 0, 1);
  -moz-box-shadow: 0px 5px 3px -7px rgba(0, 0, 0, 1);

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    border-radius: 100px;
    background-color: #00bcd4;
    background-clip: content-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/professional/contract/ProfessionalDocument.vue